/**
 * The run grammar — pure and testable.
 * Transferred verbatim in behaviour from Chirp/bittern.html `computeRuns`.
 *
 * slide[i] ties step i into step i+1 (the 303 way): a run is an on-step that
 * nothing ties into, plus every tied follower. A full bar of ties is one drone.
 */

import { computeRuns as coreComputeRuns } from '../audio/vendor/av-core.mjs';

export interface Run {
  readonly start: number;
  readonly steps: number[];
}

// SINCE AV-CORE PHASE 3 (flyway intent 2026-10-04-av-core-inline): this IS
// Chirp's single-source av-core computeRuns (../audio/vendor/av-core.mjs),
// re-exported with gesture_synth's types. Edit it in Chirp av-core/theory.js.
export const computeRuns: (mask: readonly boolean[], slide: readonly boolean[], len?: number) => Run[] =
  coreComputeRuns;
